import { render, staticRenderFns } from "./profileReping.vue?vue&type=template&id=5cde548d&"
import script from "./profileReping.vue?vue&type=script&lang=js&"
export * from "./profileReping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports